module.exports = __webpack_public_path__ + "assets/248bde237c14bf0bbdf29534e09bb556.png";